/* eslint-disable max-len */
import ActionTypes from './actions'
import ISearchState from '../../interfaces/search-state'
import initialState from './initial-state'

interface AddCityAction {
  type: ActionTypes.ADD_CITY
  payload: {
    state: string
    city: string
  }
}

interface DeleteCityAction {
  type: ActionTypes.DELETE_CITY
  payload: string
}

interface AddStateAction {
  type: ActionTypes.ADD_STATE
  payload: string[]
}

interface DeleteStateAction {
  type: ActionTypes.DELETE_STATE
  payload: string
}

interface AddSpecialtyAction {
  type: ActionTypes.ADD_SPECIALTIES
  payload: string[]
}

interface DeleteSpecialtyAction {
  type: ActionTypes.DELETE_SPECIALTY
  payload: string
}

interface AddAvailabilityAction {
  type: ActionTypes.ADD_AVAILABILITY
  payload: ISearchState['availability']
}

interface ResetFilterAction {
  type: ActionTypes.RESET_FILTERS
}

export type Action =
  | AddCityAction
  | DeleteCityAction
  | AddSpecialtyAction
  | DeleteSpecialtyAction
  | AddAvailabilityAction
  | ResetFilterAction
  | AddStateAction
  | DeleteStateAction

const searchReducer = (state: ISearchState, action: Action): ISearchState => {
  switch (action.type) {
    case ActionTypes.ADD_CITY: {
      const { state: stateToAddCity, city: cityToAdd } = action.payload

      const existingLocation = state.locations.find(
        (location) => location.state === stateToAddCity,
      )

      if (existingLocation) {
        if (!existingLocation.cities.includes(cityToAdd)) {
          const updatedLocations = state.locations.map((location) => (location.state === stateToAddCity
            ? {
              ...location,
              cities: [...location.cities, cityToAdd],
            }
            : location))

          return {
            ...state,
            locations: updatedLocations,
          }
        }
      }
      return state
    }

    case ActionTypes.DELETE_CITY: {
      const cityToDelete = action.payload

      const updatedLocationsForDelete = state.locations.map((location) => ({
        ...location,
        cities: location.cities.filter((city) => city !== cityToDelete),
      }))

      return {
        ...state,
        locations: updatedLocationsForDelete,
      }
    }

    case ActionTypes.ADD_STATE:
      return {
        ...state,
        locations: [
          ...state.locations.filter((location) => action.payload.includes(location.state)),
          ...action.payload
            .filter(
              (_state) => !state.locations.some((location) => location.state === _state),
            )
            .map((_state) => ({
              state: _state,
              cities: [],
            })),
        ],
      }

    case ActionTypes.DELETE_STATE:
      return {
        ...state,
        locations: state.locations.filter(
          (location) => location.state !== action.payload,
        ),
      }
    case ActionTypes.ADD_SPECIALTIES:
      return {
        ...state,
        specialties: action.payload,
      }
    case ActionTypes.DELETE_SPECIALTY:
      return {
        ...state,
        specialties: state.specialties.filter(
          (specialty) => specialty !== action.payload,
        ),
      }
    case ActionTypes.ADD_AVAILABILITY:
      return {
        ...state,
        availability: action.payload,
      }
    case ActionTypes.RESET_FILTERS:
      return initialState
    default:
      return state
  }
}

export default searchReducer
